import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useRef } from "react";

const UpdatePersonStatusModal = ({ show, onClose, delivery, onSave }) => {
  const [status, setStatus] = useState("");

  const dropdownRef = useRef(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setStatus("");
  }, [delivery]);

  if (!show) return null;

  const handleSave = () => {
    if (!status) {
      toast.error("Please select status!");
      return;
    }

    if (delivery) {
      onSave(delivery.id, status === "true");
    }
  };

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Update Status</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3 position-relative" ref={dropdownRef}>
              <label className="form-label">Status</label>

              {/* Dropdown Trigger */}
              <div
                className="form-control d-flex justify-content-between align-items-center cursor-pointer"
                onClick={() => setOpen((prev) => !prev)}
              >
                <span>
                  {status === ""
                    ? "Select status"
                    : status === "true"
                      ? "Active"
                      : "Inactive"}
                </span>
                <span>
                  <i
                    className={`bi bi-chevron-down transition ${
                      open ? "rotate-180" : ""
                    }`}
                  ></i>
                </span>
              </div>

              {/* Dropdown Menu */}
              {open && (
                <div
                  className="position-absolute py-3 w-100 bg-white border rounded mt-1 shadow-sm"
                  style={{ zIndex: 1056 }}
                >
                  <div
                    className="dropdown-item px-4 py-2 border-bottom"
                    onClick={() => {
                      setStatus("true");
                      setOpen(false);
                    }}
                  >
                    Active
                  </div>
                  <div
                    className="dropdown-item px-4 py-2"
                    onClick={() => {
                      setStatus("false");
                      setOpen(false);
                    }}
                  >
                    Inactive
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-light text-info" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSave}>
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePersonStatusModal;
